import React, { useState, useRef, useEffect, useCallback } from 'react';

import classnames from 'classnames'
import './SliderView.css'
import { getIcon } from '../GetMaterialIcon'
import MaterialIcon, {colorPalette} from 'material-icons-react';
import DraggableComponent from './DraggableComponent';
import { DnD_element_type, DnD_element_type_menu, DnD_element_type_category } from '../common/ConstantValues';
import DnDContext from '../DnDContext';
import { allowed_types_component, allowed_types_component_menu } from './DropContext';
import { RenderComponentDropArea } from '../ComponentDropArea';
import Row from '../ChatService/Row';
import SliderViewPageDetail from './SliderViewPageDetail';
import SlidePage from './SlidePage';
import usePrevious from '../common/usePrevious';

/**
 * 슬라이드 형태의 컴포넌트를 편집할 수 있는 Component
 * @param {Object} props 
 * @param {Array} components 
 * @param {Boolean} isMultiRow 
 * @param {Boolean} activeOverlayMenu 
 */
const SliderView = (props) => {
  // type : Inspected된 타입 객체 결과
  const {
    components, 
    isMultiRow, 
    activeOverlayMenu, 
    message_index, 
    row_index, 
    currentEditSlidePage, 
    id, 
    type, 
    disable,
    // editingIndexes,
    editing_message_index,
    editing_row_index,
    editing_slide_page_index,
    isDragging,
    messageActions,
  } = props
  const { 
    setIndex, 
    completeSlidePageDetail, 
    dropSideArea, 
    deleteSlidePage, 
    onClickLastBtn, 
    onDropInitArea, 
    onDragStart, 
    onDragEnd, 
    onCopy 
  } = props
  // const {
  //   editing_message_index,
  //   editing_row_index,
  //   editing_slide_page_index
  // } = editingIndexes
  console.log('editing_message_index :>> ', editing_message_index);
  console.log('message_index :>> ', message_index);
  console.log('editing_row_index :>> ', editing_row_index);
  console.log('row_index :>> ', row_index);
  const detailPageCondition = currentEditSlidePage && editing_message_index === message_index && editing_row_index === row_index
  const [firstPageHeight, setFirstPageHeight] = useState(null)

  const firstPageRef = useCallback((node) => {
    if (node) {
      setFirstPageHeight(node.offsetHeight)
    }
  })
  // Update timer
  let timer = null

  // Ref of slider
  const sliderRef = useRef()

  const [ _horizontalScrollValue, _setHorizontalScrollValue ] = useState(null)

  // // Previous index info
  // const prevEditIndex = usePrevious({message_index, row_index})

  // useEffect(() => {
  //   console.log('SliderView mounted ', props.row_index )
  // }, [])

  useEffect(() => {
    if (sliderRef) {
      if (sliderRef.current) {
        sliderRef.current.scrollLeft = _horizontalScrollValue
      }
    }
  }, [currentEditSlidePage])

  // useEffect(() => {
  //   return () => {
  //     console.log('unMounted ', row_index)
  //   }
  // })

  // useEffect(() => {
  //   // Logic for group
  //   if (type.type !== 'GROUP') {
  //     return
  //   }
  //   console.log('prevEditIndex :', prevEditIndex)
  //   // console.log('prevEditIndex.message_index :', prevEditIndex.message_index);
  //   // console.log('prevEditIndex.row_index :', prevEditIndex.row_index);
  //   console.log('currEditIndex.message_index :', message_index);
  //   console.log('currEditIndex.row_index :', row_index);
    
  //   if (!prevEditIndex && detailPageCondition) {
  //     console.log('이 컴포넌트가 이동됨 row_index :', row_index)
  //     console.log('components :', components);
  //   }

  //   // // Must prevEditIndex is exist
  //   // if (!prevEditIndex || 
  //   //   (prevEditIndex.message_index === null || prevEditIndex.message_index === undefined) ||
  //   //   (prevEditIndex.row_index === null || prevEditIndex.row_index === undefined)) {
  //   //   return
  //   // }

  //   // if (prevEditIndex.message_index !== message_index || prevEditIndex.row_index !== row_index) {
  //   //   console.log('그룹 컴포넌트 위치 업데이트')
  //   //   console.log('prevEditIndex :', prevEditIndex);
  //   //   console.log('currEditIndex :', {
  //   //     message_index,
  //   //     row_index,
  //   //   })
  //   // }
  //   return () => {
  //     console.log('unMounted ', row_index)
  //     console.log('components :', components)
  //   }
  // }, [message_index, row_index])

  /**
   * 'onClick' event for Group slide-page element
   * @param {Object} e 
   */
  const handlePageOnClick = (index) => {
    if (isMultiRow) {
      const { scrollLeft } = sliderRef.current
      if (index === 0 || index) {
        setIndex(parseInt(index))
        _setHorizontalScrollValue(scrollLeft)
      } else { console.error("SliderView - pageIndex를 업데이트 하지 못하였음");console.error('Slide page index :', index) }
    }
  }

  /**
   * Quit detail page function
   */
  const handleQuitSlidePageDetail = () => {
    const { quitSlidePageDetail } = props
    quitSlidePageDetail()
  }
  
  /**
   * 
   * @param {Object} e 
   */
  const handleSideAreaOnDrop = (e) => {
    dropSideArea({
      ...e,
      message_index_target: message_index,
      row_index_target: row_index,
    })
  }

  /**
   * 마지막 슬라이드 페이지 추가버튼 `onClick` handler
   * @param {Object} e 
   */
  const handleLastAddPageBtn = (e) => {
    onClickLastBtn()
    setTimeout((ref) => {
      if (ref && ref.current && components.length >= 2) { // 슬라이드 페이지가 3개부터 보여지는 영역에서 넘어감
        ref.current.scrollLeft = 9999999 // Scroll to end
        // ref.current.scrollLeft = ref.current.offsetWidth
      } else { console.error('그룹 컴포넌트 슬라이더를 오른쪽 끝으로 스크롤하지 못함 (ref및 ref.current 없음) => ', ref) }
    }, 100, sliderRef)
  }

  /**
   * 슬라이더 뷰 수평 스크롤 이벤트 핸들링
   * @param {Object} e 
   */
  const sliderViewOnScroll = (e) => {
    clearTimeout(timer)
    const { scrollLeft } = sliderRef.current
    timer = setTimeout((scrollLeft) => {
      _setHorizontalScrollValue(scrollLeft)
    }, 200, scrollLeft)
  }

  const overContent = () => (
    <div style={{minHeight:firstPageHeight, backgroundColor: '#007bff', opacity: 0.5, borderRadius: 10+'px',}}>
    </div>
  )

  const wrapper_class = classnames({
    'detail-view': detailPageCondition
  })

  // Allow type list for first drop area
  const dropAreaAllowTypes = ((type) => {
    switch(type.type) {
      case DnD_element_type.COMPONENT.NORMAL.GROUP:
        return [DnD_element_type.ELEMENT.SLIDE_PAGE, DnD_element_type_menu.ELEMENT.SLIDE_PAGE]
      case DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth:
        return [DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth, DnD_element_type_menu.COMPONENT.NORMAL.BUTTON]
      case DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth: 
        return [DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth, DnD_element_type_menu.COMPONENT.NORMAL.IMAGE]
      default:
        console.error('Type(attr) ', type.type,'에 따른 Allow types를 가져올 수 없었습니다.')
        console.info('Return allow type', [])
        return []
    }
  })(type)

  return (
    <div id='slider-view-wrapper' class={wrapper_class}>
      {
        detailPageCondition ? (
          <SliderViewPageDetail
            isDragging={isDragging}
            component={currentEditSlidePage}
            quitSlidePageDetail={handleQuitSlidePageDetail} // exit action
            completeSlidePageDetail={completeSlidePageDetail}
            message_index={message_index}
            row_index={row_index}
            deleteSlidePage={deleteSlidePage}
            onDropInitArea={onDropInitArea}
            messageActions={messageActions}
            editing_message_index= {editing_message_index}
            editing_row_index= {editing_row_index}
            editing_slide_page_index= {editing_slide_page_index}
          />
        ) : (
          <div id='component-slider' ref={sliderRef} onScroll={sliderViewOnScroll} style={{minHeight: firstPageHeight}}>
            <RenderComponentDropArea
              key={0}
              onDrop={(e) => {handleSideAreaOnDrop({...e, component_index_target: 0, isFirst: true})}}
              // DnDOverContent={null}
              DnDOverContent={overContent}
              overContentArg={null}
              // overContentArg={}
              allowed_types={dropAreaAllowTypes}
              customStyle={{display:'inline-block', width: 20, minHeight: firstPageHeight}}
            />
            {
              components.map((component, i, components) => (
                <SlidePage 
                  {...props}
                  setFirstPageHeight={setFirstPageHeight}
                  // ref={i === 0 ? firstPageRef : undefined}
                  component_index={i}
                  component={component}
                  handlePageOnClick={handlePageOnClick}
                  handleLastAddPageBtn={handleLastAddPageBtn}
                  handleSideAreaOnDrop={handleSideAreaOnDrop}
                  overContent={overContent}
                  isLast={i === components.length-1}
                  dropAreaAllowTypes={dropAreaAllowTypes}
                  messageActions={messageActions}
                  // disable included
                  // wrapStyle={{boxShadow: 'none'}}
                />
              ))
            }
          </div>
        )
      }
    </div>
  )
}



export default SliderView;